export default __webpack_public_path__ + "static/media/enterprise-edition.c245a7c0.png";